// extracted by mini-css-extract-plugin
module.exports = {"title":"title-module--title--kgv37","smaller":"title-module--smaller--3oc8h"};